import { SerializeMap } from "lib/serializerUtils";

export const simpleUserSerializerMap: SerializeMap<SimpleUser> = {
  id: "id",
  firstName: "first_name",
  lastName: "last_name",
};
